import { ThreadEvent } from "../../../../types"
import { formatDateTimeFromISO } from "../../../utils"
import { useMemo } from "react"

interface Props {
  event: ThreadEvent
}
function convertEventType(eventType: string): string {
  if (eventType === "summary_sent") {
    return "Summary Sent to LO"
  }
  return eventType
    .split("_")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ")
}

const EventItem = ({ event }: Props) => {
  const eventType = useMemo(() => convertEventType(event.type), [event.type])

  return (
    <div className="flex items-center justify-center gap-2 text-xs font-semibold my-3">
      <time dateTime={event.timestamp}>
        {formatDateTimeFromISO(event.timestamp, "h:mm:ss a EEE, M/d")}
      </time>
      <span className="border border-neutral-200 bg-neutral-100 py-1 px-3 rounded">
        {eventType}
      </span>
    </div>
  )
}
export default EventItem
